"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _reactVirtual = require("@tanstack/react-virtual");
var _theme = _interopRequireDefault(require("./theme"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useRowVirtualizer = function useRowVirtualizer(items, options) {
  var parentRef = React.useRef(null);
  var _ref = options || {},
    fetchItems = _ref.fetchItems,
    loadingStatus = _ref.loadingStatus,
    _ref$isPaginated = _ref.isPaginated,
    isPaginated = _ref$isPaginated === void 0 ? false : _ref$isPaginated,
    more = _ref.more;
  var rowVirtualizer = (0, _reactVirtual.useVirtualizer)({
    count: more || items.length === 0 ? items.length + 1 : items.length,
    getScrollElement: function getScrollElement() {
      return parentRef.current;
    },
    estimateSize: function estimateSize() {
      return _theme["default"].listItem.height;
    },
    overscan: 2
  });
  var _reverse = (0, _toConsumableArray2["default"])(rowVirtualizer.getVirtualItems()).reverse(),
    _reverse2 = (0, _slicedToArray2["default"])(_reverse, 1),
    lastItem = _reverse2[0];
  var atEndOfVirtualItems = lastItem && lastItem.index >= items.length - 1;
  var shouldFetchItems = atEndOfVirtualItems && fetchItems && loadingStatus === 'loaded' && more && isPaginated;
  React.useEffect(function () {
    if (shouldFetchItems) {
      fetchItems();
    }
  }, [shouldFetchItems, fetchItems]);
  return {
    rowVirtualizer: rowVirtualizer,
    parentRef: parentRef,
    isEmpty: items.length === 0
  };
};
var _default = exports["default"] = useRowVirtualizer;